<template>

    <div class="box">
        <b-card class="d-flex flex-column justify-content-center align-items-center specialty-card" no-body v-for="(card, index) in cards" :key="index">
            <b-row no-gutters>
                <b-col class="w-100 d-flex justify-content-center align-items-center" style="gap: .7rem">
                    <img :src="card.img" :alt="card.alt">
                    <span>{{ card.value }}</span>
                </b-col>

                <p class="text-center mt-2" style="color: var(--gray)">{{ card.text }}</p>
            </b-row>
        </b-card>
    </div>

</template>

<script>

    export default {

        data(){
            return {
                cards: [
                    { value: "+10", text: 'Anos atuando no ramo do transporte agrícola', img: require('@/assets/page/specialty/icon-car.png'), alt: "Ícone de um carro" },
                    { value: "+30", text: 'Carregamentos de pluma de algodão por mês', img: require('@/assets/page/specialty/icon-flower.png'),  alt: "Ícone de uma flor"},
                    { value: "+50", text: 'Frotistas que atendem todo o território nacional', img: require('@/assets/page/specialty/icon-people.png'),  alt: "Ícone de pessoas"},
                    { value: "100%", text: 'Seguro em todas as etapas da operação', img: require('@/assets/page/specialty/icon-ok.png'),  alt: "Ícone de escudo com um simbolobo de ok"},
                ],
            }
        }
    }

</script>

<style scoped lang="scss">

.box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
}

.specialty-card {
    width: 45%;
    min-width: 268px;
    height: 268px;
    padding: 1rem;
    border-radius: 1rem;

    img {
        width: 67px;
        height: 67px;
    }

    span {
        font-size: 3rem;
        font-weight: 800;
    }

    &:hover {
        box-shadow: 2px 2px 8px 5px #0002;
    }
}

</style>